<template>
  <div class="add_warp">
    <div>
      <div class="courseInfo">课程信息</div>
      <formCustom
        :data="searchHeaders"
        :bindProps="{ 'label-width': '124px', 'scroll-to-error': true }"
        :ruleForm.sync="classruleForm"
        :formRef.sync="formRef"
      >
      </formCustom>
    </div>
    <!-- <div v-if="showCate">
      <div class="courseInfo">商品参数</div>
      <formCustom
        :data="commodities"
        :bindProps="{ 'label-width': '124px', 'scroll-to-error': true }"
        :ruleForm.sync="commoditiesRuleForm"
        :formRef.sync="commoditiesFormRef"
      >
      </formCustom>
    </div> -->
    <div class="from_item_con">
      <el-button type="primary" @click="submitForm()">提交审核</el-button>
      <!-- <el-button type="primary" @click="submitForm(2)">保存草稿</el-button>
      <el-button type="primary" @click="submitForm(1)">上架</el-button> -->
    </div>
    <!-- <previewData v-model="classruleForm"></previewData> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { deepClone } from "lodash-unified";
import formCustom from "../../../components/useTable/customForm";
import addCourseSelect from "../../../components/virtualizedSelect/addCourseSelect.vue";
import uploadImage from "./components/uploadImg/uploadImg.vue";
// import previewData from "./components/previewData/previewData.vue";
import searchCascader from "../../../components/searchCascader/searchCascader.vue";
import { strLength } from "@/utils/index";
import { numberTransform } from "@/utils/utils.js"
const formProps = {
  style: {
    marginBottom: "0",
    marginRight: "16px",
  },
};
export default {
  components: {
    formCustom,
    addCourseSelect,
    uploadImage,
    // previewData,
    searchCascader,
  },
  data() {
    return {
      f_cat_id: 381003,
      selDisable:false,
      classruleForm: {
        product_id: "",
        cat_id: [],
        title: "",
        price: "", // 课程价格（元）
        description: "", // 课程文字描述
        image_descriptions: [], // 详情图
        images: [], // 主图
        brand_id: '' // 品牌id
      },
      commoditiesRuleForm: {},
      formRef: {},
      commoditiesFormRef: {},
      isHttpFlag: false,
      searchHeaders: [
        {
          label: "选择课程",
          Component: addCourseSelect,
          prop: "product_id",
          defaultValue: "",
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "请选择课程",
            },
            ...formProps,
          },
          componentProps: {
            // clearable:true,
            style: {
              width: "240px",
            },
            filterable: true,
            placeholder: "选择课程",
            selectProps: {
              label: "title",
              value: "id",
              disable:'disabled'
            },
            disable:this.selDisable,
            httpRequest: async (params) => {
              let res = await this.getProductSelect(params);
              let data = {
                total: res.count,
                data: res.data,
              };
              this.classruleForm.product_id = this.classruleForm.product_id
                ? this.classruleForm.product_id
                : data?.data[0]?.product_id;
              return data;
            },
          },
          afterSlot: () => (
            <span style="font-size:12px;margin-left:8px;">
              <span style="color:#666;margin-right:4px;">
                小红书课程需要和您已创建的微信小程序课程（必须已上架）进行关联
              </span>
              <span style="color:red;">
                注意：小店商品与小程序课程是一对一关系
              </span>
            </span>
          ),
        },
        {
          label: "课程分类",
          prop: "cat_id",
          Component: searchCascader,
          componentProps: {
            placeholder: "请选择分类",
            style: {
              width: "240px",
            },
            selectProps: {
              label: "name",
              value: "id",
              lazy: true,
              lazyLoad: async (node, resolve) => {
                const { level } = node;
                let res = [];
                if (level == 0) {
                  res = await this.getCategory();
                } else {
                  res = await this.getCategory({ parent_id: node.value });
                }
                res = res.map((item) => {
                  return {
                    ...item,
                    leaf: level >= 2,
                  };
                });
                resolve(res);
              },
            },
            // httpRequest: async (params) => {
            //   let res = await this.getCategory(params);
            //   return res;
            // },
            // filterable,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "请选择分类",
            },
            ...formProps,
          },
        },
        {
          label: "品牌",
          prop: "brand_id",
          Component: "el-select",
          componentProps: {
            placeholder: "请选择分类",
            style: {
              width: "240px",
            },
            'no-data-text': '请先选择课程分类...'
            // filterable,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "请选择品牌",
            },
            ...formProps,
          },
          componentSlots: {
            default: () => {
              let arr = [] 
              return arr.map((item) => {
                return (
                  <el-option value={item.value} label={item.label} key={item.value}></el-option>
                );
              });
            },
          },
        },
        {
          label: "课程标题",
          prop: "title",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "请输入课程标题",
            style: {
              width: "240px",
            },
            maxLength: 60,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",

              validator: (rule, value, callback) => {
                if (value === "") {
                  callback(new Error("请输入课程标题"));
                }
                const len = strLength(value);
                if (len < 16) {
                  callback(new Error("课程标题需至少8个汉字或16个字符"));
                }
                callback();
              },
            },
          },
        },
        {
          label: "课程售价",
          prop: "price",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "支持小数点后两位",
            style: {
              width: "240px",
            },
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "请输入课程售价",
            },
          },
          afterSlot: () => (
            <span style="font-size:12px;margin-left:8px;">
              <span style="color:#666;margin-right:4px;">
                元
              </span>
            </span>
          ),
        },
        {
          label: "封面主图",
          prop: "images",
          Component: uploadImage,
          defaultValue: "",
          beforeSlot: () => (
            <div style="font-size:12px; color:#666;">
              请上传1张图片，仅支持格式JPG/JPEG/PNG，尺寸比1:1或3:4，大小3M以内。
            </div>
          ),
          componentProps: {
            // placeholder: "支持小数点后两位，免费则输入0",
            style: {
              width: "240px",
            },
            limit: 1,
            maxSize: 3,
            needCut: true,
            addText: '添加主图',
            accept: [".jpg", ".png", ".jpeg"]
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              validator: (rule, value, callback) => {
                if (!value.length) {
                  callback(new Error("请上传封面主图"));
                }
                // if (value.length < 3) {
                //   callback(new Error("封面主图至少上传3张"));
                // }
              },
            },
          },
        },
        {
          label: "详情描述",
          prop: "description",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "请输入",
            style: {
              width: "240px",
            },
            type: "textarea",
            rows: 8,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "请输入详情描述"
            },
          },
        },
        {
          label: "详情图片",
          prop: "image_descriptions",
          Component: uploadImage,
          defaultValue: "",
          beforeSlot: () => (
            <div style="font-size:12px; color:#666;">
              文描所有图片高度总和不得超过 50000px，图片格式支持JPG/JPEG/PNG；单张图片需限制在10M以内
            </div>
          ),
          componentProps: {
            style: {
              width: "240px",
            },
            limit: 19,
            maxSize: 10,
            accept: [".jpg", ".png", ".jpeg"]
          },
          formProps: {
            rules: {
              required: true,
            },
          },
        },
      ],
      commodities: [],
      commoditiesData: [],
      // commoditiesValue: [],
      // commoditiesValueEdit:[],
      // showCate: false,
      class_id: null, // 课程id(编辑需要传)
      isFirst: true,
    };
  },

  created() {
    this.class_id = this.$route.params.id ? this.$route.params.id : null;
    console.log('hhhh-class_id:',this.class_id)
    if (this.class_id) {
      this.getEditClassData();
    }
  },
  methods: {
    ...mapActions("wxVideo", [
      // "videoClassCategory",
      "videoClassProduct",
      // "videoClassInfo",
    ]),
    ...mapActions("xhsApis", ["getClassCategoryAPI", "getBrandAPI", "handleClassAPI", "getClassDetailInfoAPI"]),
    async getProductSelect(params) {
      let res = await this.videoClassProduct({ ...params });
      return res;
    },
    // 更新品牌列表组件
    async changeBrandComp(cateId){ // cateId 课程分类id
      let res = await this.getBrandAPI({cate_id: cateId})
      // console.log('changeBrandComp-res:',res)
      let componentSlots = {
        default: () => {
          return res.map((item) => {
            return (
              <el-option value={item.id} label={item.name} key={item.id}></el-option>
            );
          });
        },
      }
      let targetIndex = this.searchHeaders.findIndex(item => item.prop==='brand_id')
      this.searchHeaders[targetIndex].componentSlots = componentSlots
    },
    // 获取课程分类
    async getCategory(params) {
      let res = await this.getClassCategoryAPI({ ...params });
      // console.log('getCategory-res:',res)
      return res;
    },
    toObject(pairs,type) {
      return pairs.reduce(
        (obj, item, cindex) => (
          (obj["attr_key" + cindex] = type==1?item.attr_value:""), obj
        ),
        {}
      );
    },
    submitForm(type) {
      let keys = { ...this.classruleForm };
      keys.first_cate_id = keys.cat_id[0] || '' // 一级分类ID
      keys.second_cate_id = keys.cat_id[1] || '' // 二级分类ID
      keys.three_cate_id = keys.cat_id[2] || '' // 三级分类ID
      delete keys.cat_id
      this.submit(keys);
    },
    async submit(data) {
      if (this.class_id) {
        await this.handleClassAPI({ ...data, id: this.class_id })
      } else {
        await this.handleClassAPI( data )
      }
      this.$message({
        type: "success",
        message: "提交成功",
      });
      this.$router.go(-1);
    },

    async getEditClassData() {
      let res = await this.getClassDetailInfoAPI({ id: this.class_id });
      res.image_descriptions = JSON.parse(res.image_descriptions)
      res.images = JSON.parse(res.images)
      res.price = numberTransform(res.price/100)
      console.log('getEditClassData-res:',res)

      let data = { ...res };
      data.cat_id = [data.first_cate_id, data.second_cate_id, data.three_cate_id]
      delete data.first_cate_id
      delete data.second_cate_id
      delete data.three_cate_id
      // this.selDisable = data.status ==0?false:true // 禁用，但是条件不确定
      for (const key in this.classruleForm) {
        if (data[key]) {
          this.classruleForm[key] = data[key];
        }
      }
    },
  },
  watch: {
    "classruleForm.cat_id"(news) {
      if (news.length) {
        // console.log('classruleForm.cat_id:',news)
        this.changeBrandComp(news[news.length-1])
      }
    },
  },
};
</script>

<style lang="less">
.courseInfo {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}
.from_item_con {
  width: 100%;
  display: flex;
  justify-content: center;
}
.add_warp {
  width: 100%;
  position: relative;
}
</style>